<template>
    <div class="statistics-details-root">
        <template v-for="({label: typeLabel, values}, index) in statisticsDetails">
            <div class="statistics-details-table-container" :key="`${typeLabel}-${index}`">
                <table class="statistics-details-table">
                    <thead>
                    <tr>
                        <th class="statistics-details-label-cell set-label-cell">&nbsp;</th>
                        <th v-for="({label}, index) in values"
                            :key="`${label}-${index}`"
                            :width="`${cellWidthPerType[typeLabel]}%`"
                            
                            class="statistics-details-label-cell values-label-cell"
                            :class="{ selected: selectedTypeFiltersLookup[typeLabel][label] }"

                            @click="filterSelected(typeLabel, label)"
                        >
                            {{label}}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td class="statistics-details-label-cell set-label-cell">
                            <span>
                                {{typeLabel}}
                            </span>
                        </td>
                        <td v-for="({value, label}, index) in values"
                            :key="`${label}-${index}`"
                            :width="`${cellWidthPerType[typeLabel]}%`"
                            
                            class="values-label-cell"
                            :class="{ selected: selectedTypeFiltersLookup[typeLabel][label] }"
                        >
                            {{value | formatNumber}}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </div>
</template>

<script>
    import formattedNumberFilterMixin from '../../../../Mixins/formatted-number-filter';

    export default {
        name: 'touchpoint-statistics-details',
        mixins: [formattedNumberFilterMixin],
        methods: {
            filterSelected(typeLabel, label) {
                const { selectedTypeFilters } = this;

                //Find, or add our current type filter collection
                const currentTypeFilterIndex = selectedTypeFilters.findIndex(({label}) => label === typeLabel);
                const currentTypeFilter = selectedTypeFilters[currentTypeFilterIndex] || {
                    label: typeLabel,
                    values: []
                };

                if(currentTypeFilterIndex === -1){
                    selectedTypeFilters.push(currentTypeFilter);
                }

                //Remove on second 'selection'
                const currentTypeFilterLabelIndex=  currentTypeFilter.values.indexOf(label);
                if(currentTypeFilterLabelIndex !== -1){
                    currentTypeFilter.values.splice(currentTypeFilterLabelIndex, 1);
                }
                else{
                    currentTypeFilter.values.push(label);
                }

                //Filters serve no purpose anymore
                //and thus should be removed to avoid potential confusion
                if(currentTypeFilter.values.length === 0 && currentTypeFilterIndex !== -1){
                    selectedTypeFilters.splice(currentTypeFilterIndex, 1);
                }
                
                this.$emit('filters-changed', selectedTypeFilters);
            }
        },
        computed: {
            selectedTypeFiltersLookup(){
                const vm = this;
                const selectedTypeFilters = vm.selectedTypeFilters;

                //Lookup for each available type containing a lookup with all selected filter labels
                
                return vm.statisticsDetails.reduce((selectedTypeFiltersObj, {label: typeLabel}) => {
                    const currentTypeSelectedFilters = {};
                    selectedTypeFiltersObj[typeLabel] = currentTypeSelectedFilters;
                    
                    const {values: selectedValues} = selectedTypeFilters.find(({label}) => label === typeLabel) || {values: []};

                    selectedValues.forEach(label => currentTypeSelectedFilters[label] = true);
                    
                    return selectedTypeFiltersObj;
                }, {});
            },
            cellWidthPerType(){
                return this.statisticsDetails.reduce((widthPerType, {label: typeLabel, values: { length: valueCount }}) => {
                    //Math.floor(...) as to never exceed the full 100%
                    widthPerType[typeLabel] = Math.floor(100 / valueCount);
                    
                    return widthPerType;
                }, {});
            }
        },
        data: () => ({
            /*
                [{label: '....', values: [....]}]
            */
            
            selectedTypeFilters: []
        }),
        props: {
            /*
                {
                    label: '...',
                    values: [{
                        label: '...'
                        value: ...
                    }]
                }
            
             */
            
            statisticsDetails: null
        }
    }
</script>

<style scoped lang="scss" src="../../../../Style/touchpoint-statistics-details.scss" />
